import { createOrders, updateOrders } from "../../helpers/generateOrdersPayload";
import { notification } from "antd";
import { ActionTypes } from "../constants/actionTypes";
import { apiService } from "../../services/apiServices";
import _ from "lodash";

export const createOrUpdateOrders = (
    data,
    authParams,
    history,
    handleError,
  ) => {
    return async (dispatch) => {
      dispatch({ type: ActionTypes.SET_LOADER });
      notification.info({
        message: "File Process Started",
        placement: "bottomRight",
      });
  
      const groupedData = _.groupBy(data, (e) => e?.id);
      const orderIds = Object.keys(groupedData);
  
      if (!orderIds.length) return
  
      try {
        const orderRes = await apiService.validateOrderIds({
          entityIds: orderIds,
          allowInactive: false,
        }, authParams);
  
        const { entityIds: orderIdsInLocus = [], availableIds: orderIdsNotInLocus = [] } = orderRes?.data || {};
  
        // orders not existing needs to be created
        const createdOrders = await createOrders(authParams, orderIdsNotInLocus, groupedData);
  
        //orders existing should needs to be updated upon checking the status
        const updatedOrders = await updateOrders(authParams, orderIdsInLocus, groupedData);
        
        notification.success({
          message: "File Process Finished",
          placement: "bottomRight",
        });
        
        return {createdOrders, updatedOrders};
      } catch ({ response = {} }) {
        notification.error({ message: "Error in Processing Files", placement: 'bottomRight' });
        const { data = "Network Error!", status } = response;
        if (status === 401) return history("/unauthorized");
        handleError({ data });
      } finally {
        dispatch({ type: ActionTypes.UNSET_LOADER });
      }
    };
  };
  